module.exports = __webpack_public_path__ + "static/media/logo-tray.644ebe48.svg";